var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotHex = function SvgHotspotHex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M7.739 1.57a.52.52 0 0 1 .522 0l5.177 2.989a.52.52 0 0 1 .261.452v5.978c0 .186-.1.359-.261.452L8.26 14.43a.52.52 0 0 1-.522 0l-5.177-2.989a.52.52 0 0 1-.261-.452V5.01c0-.186.1-.359.261-.452z"
  })));
};
export default SvgHotspotHex;